export const NAV_EXPERIENCE_PATH_SERVICE = '/services/nav/v1/experience';